import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { img } from "../lib/api";
import { useApp } from "../context/AppContext";

import { tx, useLang, soldLabel } from "../lib/i18n";
export const ProductCard = ({ p, idx = 0 }) => { useLang();
  const { formatPrice, wishIds, toggleWish, t } = useApp();
  const saved = wishIds.includes(p.product_id);
  const cutout = p.image?.includes("/hero/");
  const href = `/product/${p.slug}${p.shared_via ? `?via=${p.shared_via}` : ""}`;
  return (
    <div className="group mv-reveal" style={{ animationDelay: `${idx * 60}ms` }} data-testid={`product-card-${p.slug}`}>
      <Link to={href} className="block overflow-hidden rounded-2xl border border-[var(--mv-border)] mv-card-bg transition-colors group-hover:border-[var(--mv-border-2)]" data-testid={`product-card-link-${p.slug}`}>
        <div className="relative aspect-[4/3.6]">
          {tx(p.is_new && <span className="absolute left-3 top-3 z-10 rounded-md bg-[var(--mv-teal)] px-2 py-0.5 text-[10px] font-bold text-[#05090b]">{t("common.new")}</span>)}
          {!p.image ? <div className="grid h-full w-full place-items-center bg-[var(--mv-card)] text-[11px] tracking-[0.3em] text-[var(--mv-dim)]" data-testid={`product-card-noimage-${p.slug}`}>MIVO</div> : <img src={img(p.image)} alt={p.title} loading="lazy"
            className={`h-full w-full transition-transform duration-500 group-hover:scale-[1.04] ${cutout ? "object-contain p-6" : "object-cover"}`} />}
        </div>
      </Link>
      <div className="mt-3 flex items-start justify-between gap-2 px-0.5">
        <div className="min-w-0">
          <Link to={href} className="block truncate text-sm font-semibold text-[var(--mv-text)] hover:text-[var(--mv-teal)]">{p.title}</Link>
          <p className="mt-1 text-sm text-[var(--mv-muted)]" data-testid={`product-card-price-${p.slug}`}>
            {formatPrice(p.price_cents)}{tx(p.price_max_cents > p.price_cents ? "+" : "")}
            {p.sold_count > 0 && <span className="ml-2 text-[11px] text-[var(--mv-dim)]" data-testid={`product-card-sold-${p.slug}`}>{soldLabel(p.sold_count)}</span>}
          </p>
          {p.fulfilled_by && <p className="mt-0.5 text-[11px] text-[var(--mv-teal)]" data-testid={`product-card-fulfilled-${p.slug}`}>{tx("Fulfilled by MIVO")}</p>}
        </div>
        <button onClick={() => toggleWish(p.product_id)} data-testid={`product-card-heart-${p.slug}`} aria-pressed={saved} aria-label={t("common.wishlist")}
          className="grid h-8 w-8 shrink-0 place-items-center rounded-full hover:bg-white/5 transition-colors">
          <Heart className={`h-[18px] w-[18px] transition-colors ${saved ? "fill-[var(--mv-teal)] text-[var(--mv-teal)]" : "text-[var(--mv-text)]"}`} />
        </button>
      </div>
    </div>
  );
};

export const ProductGrid = ({ items, cols = "grid-cols-2 md:grid-cols-3 lg:grid-cols-4", testid = "product-grid" }) => { useLang(); return (
  <div className={`grid ${cols} gap-x-5 gap-y-8`} data-testid={testid}>
    {items.map((p, i) => <ProductCard key={p.product_id} p={p} idx={i} />)}
  </div>
); };
